<mat-card *ngIf="total">
    <mat-card-header>
        <mat-card-title>
            {{ 'billing.CRM.total.title' | translate }}
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <table>
            <tr>
                <th>{{ 'billing.CRM.total.numberOfOrders' | translate }}</th>
                <td>{{total.numberOfOrders | number:'1.0-0'}}</td>
            </tr>
            <tr>
                <th>{{ 'billing.CRM.total.numberOfExtraOrders' | translate }}</th>
                <td>{{total.numberOfExtraOrders | number:'1.0-0'}}</td>
            </tr>
            <tr>
                <th>{{ 'billing.CRM.total.price' | translate }}</th>
                <td>{{total.price | number:'1.2-2' }} €</td>
            </tr>
            <tr>
                <th>{{ 'billing.CRM.total.extraPrice' | translate }}</th>
                <td>{{total.extraPrice | number:'1.2-2' }} €</td>
            </tr>
            <tr>
                <th colspan="2">
                    <hr>
                </th>
            </tr>
            <tr>
                <th>{{ 'billing.CRM.total.totalPrice' | translate }}</th>
                <td class="totalPrice">{{total.totalPrice | number:'1.2-2' }} €</td>
            </tr>
        </table>
    </mat-card-content>
</mat-card>